import { render, staticRenderFns } from "./EditSuggest.vue?vue&type=template&id=6f3ce4dd&"
import script from "./EditSuggest.vue?vue&type=script&lang=js&"
export * from "./EditSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports